<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="salesSetupAdyenClientKey"
                    id="salesSetupAdyenClientKey"
                    matInput
                    [placeholder]="
                    'adyen.clientKey' |
                    translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="salesSetupAdyenApiKey"
                    id="salesSetupAdyenApiKey"
                    matInput
                    [placeholder]="
                    'adyen.apiKey' |
                    translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="salesSetupAdyenMerchantAccount"
                    id="salesSetupAdyenMerchantAccount"
                    matInput
                    [placeholder]="
                    'adyen.merchantAccount' |
                    translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50" *ngIf="!D2SPaymentConfiguration">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="salesSetupAdyenliveEndpointURLPrefix"
                    id="salesSetupAdyenliveEndpointURLPrefix"
                    matInput
                    [placeholder]="
                    'adyen.URLPrefix' |
                    translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50" *ngIf="D2SPaymentConfiguration">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="liveEndPointUrlPrefix"
                    id="liveEndPointUrlPrefix"
                    matInput
                    [placeholder]="
                    'adyen.URLPrefix' |
                    translate"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
